module.exports = __webpack_public_path__ + "img/bg_festa7.b60a2033.jpg";